<template>
  <div v-show="notify" class="notifier">
    <div  v-if="message" class="alert alert-success">
      {{ message }}
    </div>
    <div v-else v-for="(errorArray, idx) in errors" :key="idx">
      <div v-for="(allErrors, idx) in errorArray" :key="idx">
        <div class="alert alert-danger">{{ allErrors }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotifierComponent",
  props: {
    notify: {
      type: String,
    },
    message: {
      type: String,
    },
    errors: {
      type: Array,
    },
  },
  data() {
    return {
      elementVisible: true,
    };
  },
  beforeUpdate() {
    setTimeout(() => (this.$parent.$data.notify = false), 5000);
  },
};
</script>

<style scoped>
.alert {
  padding: 10px 10px;
  font-size: 15px;
}
</style>
